import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import {BuilderPage} from "./pages/BuilderPage";
import {MyPage} from "./pages/MyPage";
import {DashboardPage} from "./pages/DashboardPage";

const DevicePage = lazy(() =>
    import("./modules/Device/pages/DevicePage")
);

const AccountPage = lazy(() =>
    import("./modules/Account/pages/AccountPage")
);

const SiteMapPage = lazy(() =>
    import("./modules/Sitemap/pages/SiteMapPage")
);

const ConfigurationsPage = lazy(() =>
    import("./modules/Configuration/pages/ConfigurationPage")
);
const AutomationPage = lazy(() =>
    import("./modules/Automation/pages/AutomationPage")
);
const ManufacturersPage = lazy(() =>
    import("./modules/Manufacturer/pages/ManufacturerPage")
);
const SettingPage = lazy(() =>
    import("./modules/Settings/pages/SettingPage")
);
const UpdatePage = lazy(() =>
    import("./modules/Update/pages/UpdatePage")
);
const DevelopmentEntrace = lazy(() =>
    import("./modules/Development/pages/DevelopmentEntrance")
);
const AccessControlEntrance = lazy(() =>
    import("./modules/AccessControl/pages/AccessControlEntrance")
);
export default function BasePage() {

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/dashboard"/>
                }

                <ContentRoute path="/dashboard" component={DashboardPage}/>
                <Route path="/accesscontrol" component={AccessControlEntrance}/>
                <Route path="/device" component={DevicePage}/>
                <Route path="/account" component={AccountPage}/>
                <Route path="/sitemap" component={SiteMapPage}/>

                <Route path="/configurations" component={ConfigurationsPage}/>
                <Route path="/automation" component={AutomationPage}/>

                <Route path="/manufacturer" component={ManufacturersPage}/>
                <Route path="/thingdefinitions" component={ManufacturersPage}/>
                <Route path="/thingchanneltypes" component={ManufacturersPage}/>
                <Route path="/thingchanneldefinitions" component={ManufacturersPage}/>

                <Route path="/settings" component={SettingPage}/>
                <Route path="/update" component={UpdatePage}/>
                <Route path="/development" component={DevelopmentEntrace}/>

                {/*
                  <ContentRoute path="/builder" component={BuilderPage}/>
                  <ContentRoute path="/my-page" component={MyPage}/>
                  <Route path="/google-material" component={GoogleMaterialPage}/>
                  <Route path="/react-bootstrap" component={ReactBootstrapPage}/>
                  <Route path="/e-commerce" component={ECommercePage}/>
                  <Route path="/Panel" component={PanelPage}/>
                  <Route path="/user" component={UserPage}/>                
                 */}

                {/* <Redirect to="/error/error-v1"/> */}
            </Switch>
        </Suspense>
    );
}
